// Mock data for Dog Boarding Baltimore

export const heroData = {
  headline: "Baltimore's Most Trusted Dog Boarding",
  subheadline: "Locally owned & operated. Background-checked staff. Trusted by your neighbors for 5+ years.",
  ctaText: "Get Your Free Quote",
  image: "https://images.pexels.com/photos/2253275/pexels-photo-2253275.jpeg"
};

export const trustBadges = [
  {
    id: 1,
    icon: "ShieldCheck",
    title: "Background Checked",
    description: "Every team member passes comprehensive background screening"
  },
  {
    id: 2,
    icon: "MapPin",
    title: "Locally Owned",
    description: "Baltimore-based family business, not a corporate chain"
  },
  {
    id: 3,
    icon: "Clock",
    title: "5+ Years Trusted",
    description: "Serving Baltimore neighborhoods since 2019"
  },
  {
    id: 4,
    icon: "Heart",
    title: "Neighbor Approved",
    description: "Recommended by families throughout Baltimore"
  }
];

export const services = [
  {
    id: 1,
    title: "Overnight Boarding",
    description: "Your pup sleeps in a cozy, climate-controlled space with evening walks and bedtime snuggles.",
    icon: "Moon",
    image: "https://images.pexels.com/photos/1174081/pexels-photo-1174081.jpeg"
  },
  {
    id: 2,
    title: "Doggy Daycare",
    description: "Supervised playtime, socialization, and exercise to keep your dog happy while you work.",
    icon: "Sun",
    image: "https://images.pexels.com/photos/998254/pexels-photo-998254.jpeg"
  },
  {
    id: 3,
    title: "Extended Stays",
    description: "Going on vacation? We provide the same loving care for a week or longer.",
    icon: "Calendar",
    image: "https://images.pexels.com/photos/35144741/pexels-photo-35144741.jpeg"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah M.",
    location: "Federal Hill",
    rating: 5,
    text: "Finally found a boarding service I can trust! The staff treats my golden retriever like family. Knowing they're all background checked gives me total peace of mind.",
    dogName: "Max"
  },
  {
    id: 2,
    name: "James T.",
    location: "Canton",
    rating: 5,
    text: "We've been using Dog Boarding Baltimore for 3 years now. They're locally owned and you can tell they genuinely care. Our neighbors recommended them and now I do too!",
    dogName: "Bella"
  },
  {
    id: 3,
    name: "Michelle K.",
    location: "Hampden",
    rating: 5,
    text: "The daily photo updates make my trips so much easier. I love that they're a local Baltimore business - they know our community and treat every dog like their own.",
    dogName: "Cooper"
  },
  {
    id: 4,
    name: "David R.",
    location: "Fells Point",
    rating: 5,
    text: "After trying several boarding facilities, this is the only one where my anxious rescue actually seems happy. The background-checked staff are true professionals.",
    dogName: "Luna"
  }
];

export const faqs = [
  {
    question: "Are all staff members background checked?",
    answer: "Absolutely. Every single team member undergoes a comprehensive background check before joining our team. Your pet's safety is our #1 priority."
  },
  {
    question: "What makes you different from chain boarding facilities?",
    answer: "We're locally owned and operated by a Baltimore family. You'll see the same caring faces every visit, and we treat your dog like our own. No corporate quotas - just genuine love for dogs."
  },
  {
    question: "How long have you been serving Baltimore?",
    answer: "We've been proudly serving Baltimore neighborhoods for over 5 years. Many of our clients come through neighbor recommendations!"
  },
  {
    question: "What do I need to bring for my dog's stay?",
    answer: "Just your dog's regular food, any medications, and a favorite toy or blanket. We provide bedding, bowls, and lots of love!"
  },
  {
    question: "Do you send updates during my dog's stay?",
    answer: "Yes! We send daily photo and video updates so you can see your furry friend having a great time."
  },
  {
    question: "What areas of Baltimore do you serve?",
    answer: "We serve all of Baltimore and surrounding areas including Federal Hill, Canton, Fells Point, Hampden, Roland Park, Towson, and more."
  }
];

export const stats = [
  { value: "5+", label: "Years Serving Baltimore" },
  { value: "50+", label: "Happy Dogs Boarded" },
  { value: "100%", label: "Background Checked Staff" },
  { value: "4.9", label: "Average Rating" }
];

export const contactInfo = {
  email: "team@dogboardingbaltimore.com",
  address: "Baltimore, MD",
  hours: "7 AM - 8 PM Daily"
};
